import Cookies from 'js-cookie';

const CookieConsent = {
  COOKIE_NAME: 'cookie_consent',
  existingCookie: null,
  banner: document.querySelector('[data-cc]'),
  apply: document.querySelector('[data-cc-apply]'),
  applyAll: document.querySelector('[data-cc-apply-all]'),
  groups: document.querySelectorAll('[data-cc-groups]'),

  init() {
    this.initExistingCookie();
    this.cleanUpExistingCookies();
    this.initEventHandlers();
    this.checkGroups();
  },

  initExistingCookie() {
    if (!this.existingCookie) {
      const cookie = Cookies.get(this.COOKIE_NAME);

      if (cookie) {
        this.existingCookie = JSON.parse(cookie);
      }
    }

    return this.existingCookie;
  },

  cleanUpExistingCookies() {
    if (this.existingCookie) {
      return;
    }

    const self = this;

    Object.keys(Cookies.get()).forEach((cookie) => {
      if (cookie !== self.COOKIE_NAME && cookie.includes('SESS')) {
        Cookies.remove(cookie, { path: '/' });
        Cookies.remove(cookie, {
          domain: `.${window.location.hostname.replace('www.', '')}`,
          path: '/',
        });
      }
    });
  },

  initEventHandlers() {
    this.handleApply();
    this.handleApplyAll();
  },

  handleApply() {
    const self = this;

    this.apply.addEventListener('click', (e) => {
      e.preventDefault();

      const groups = [];

      self.groups.forEach((group) => {
        if (group.checked) {
          groups.push(group.value);
        }
      });

      self.setCookie('ALLOW', groups);

      self.close();

      window.location.reload(false);
    });
  },

  handleApplyAll() {
    const self = this;

    this.applyAll.addEventListener('click', (e) => {
      e.preventDefault();

      const groups = [];

      self.groups.forEach((group) => {
        groups.push(group.value);
      });

      self.setCookie('ALLOW', groups);

      self.close();

      window.location.reload(false);
    });
  },

  open() {
    this.banner.style.display = '';
  },

  close() {
    this.banner.style.display = 'none';
  },

  deny() {
    const self = this;

    Object.keys(Cookies.get()).forEach((cookie) => {
      if (cookie !== self.COOKIE_NAME && cookie.startsWith('SESS')) {
        Cookies.remove(cookie, { path: '/' });
        Cookies.remove(cookie, {
          domain: `.${window.location.hostname.replace('www.', '')}`,
          path: '/',
        });
      }
    });

    self.setCookie('DENY', []);

    self.close();

    window.location.reload(false);
  },

  checkGroups() {
    const self = this;

    if (!self.existingCookie) {
      return;
    }

    if (!Array.isArray(self.existingCookie.groups)) {
      return;
    }

    self.groups.forEach((group) => {
      if (self.existingCookie.groups.indexOf(group.value) !== -1) {
        group.checked = true;
      }
    });
  },

  setCookie(method, groups) {
    Cookies.set(
      this.COOKIE_NAME,
      JSON.stringify({
        method,
        groups,
      }),
      {
        path: '/',
        domain: `.${window.location.hostname.replace('www.', '')}`,
        expires: 365,
      }
    );
  },
}.init();
